module.exports = __webpack_public_path__ + "static/media/frame-win.a337a372.png";